import { createFileRoute, redirect } from '@tanstack/react-router'

import { authToken } from '@/hooks/use-auth'

export const Route = createFileRoute('/')({
	beforeLoad: () => {
		if (!authToken.value) {
			throw redirect({
				to: '/login',
				search: {
					redirect: location.pathname === '/' ? undefined : location.pathname
				}
			})
		} else {
			throw redirect({
				to: '/analytics'
			})
		}
	}
})
